import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  background: ${colors.surfaceContainerLow};
  border: 1px solid transparent;
  border-radius: ${radius.lg};

  transition: border-color 0.2s;

  &:hover {
    border-color: ${colors.primary}33;
  }
`;

interface ContainerImgProps {
  compact?: boolean;
}

export const ContainerImg = styled.div<ContainerImgProps>`
  position: relative;
  width: 100%;
  height: ${({ compact }) => (compact ? '110px' : '176px')};

  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Tag = styled.span`
  position: absolute;
  left: 12px;
  bottom: 12px;

  padding: 4px 10px;
  border-radius: ${radius.DEFAULT};

  background-color: ${colors.primary}e6;
  color: ${colors.onPrimary};

  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const VideoBadge = styled.span`
  position: absolute;
  right: 12px;
  bottom: 12px;

  width: 26px;
  height: 26px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.surfaceContainerHighest}e6;
  color: ${colors.onSurface};
`;

export const LibraryTag = styled.span`
  position: absolute;
  right: 12px;
  top: 12px;

  padding: 4px 10px;
  border-radius: ${radius.DEFAULT};

  background-color: ${colors.surfaceContainerHighest}e6;
  color: ${colors.onSurfaceVariant};

  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

interface ContainerContentProps {
  compact?: boolean;
}

export const ContainerContent = styled.div<ContainerContentProps>`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${({ compact }) => (compact ? '14px' : '24px')};
`;

export const Title = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const Subtitle = styled.span`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
  margin-top: 12px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 40px;
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  margin-top: 20px;
`;

export const DetailsButton = styled.button`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  padding: 10px;

  background: transparent;
  border: 1px solid ${colors.outlineVariant}4d;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurface};

  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const AddButton = styled.button`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  padding: 10px;

  background-color: ${colors.primary};
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onPrimary};

  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const RemoveButton = styled.button`
  flex-shrink: 0;

  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: 1px solid ${colors.outlineVariant}4d;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  color: ${colors.onSurfaceVariant};

  transition: color 0.2s, border-color 0.2s;

  &:hover {
    color: ${colors.error};
    border-color: ${colors.error}4d;
  }
`;
